import { BookIcon, BookOpenIcon, BriefcaseIcon, FileIcon, ParenthesisIcon, CheckMarkCircleIcon } from 'resources/icons';

import { NavLink } from 'react-router-dom';
import { getLinkToJob, getLinkToRule, getLinkToVariable, getLinkToGroup, ROUTE_NOT_FOUND, ADMIN_DATA_CERTIFICATIONS } from '../../../navigator/links';
import { SideBarMenuOptions } from '../../../types/side-bar-menu-options';
import './index.css';

type SideExplorerEntryProps = {
  id: string;
  text: string;
  type: SideBarMenuOptions;
};

function getIconDecorator(type: SideBarMenuOptions): JSX.Element {
  switch (type) {
    case 'Jobs':
      return <BriefcaseIcon />;
    case 'Groups':
      return <BookIcon />;
    case 'Rules':
      return <BookOpenIcon />;
    case 'Variables':
      return <ParenthesisIcon />;
    case 'Data Certifications':
      return <CheckMarkCircleIcon />;
    default:
      return <FileIcon />;
  }
}

function getLink(type: SideBarMenuOptions, name: string): string {
  switch (type) {
    case 'Jobs':
      return getLinkToJob(name);
    case 'Rules':
      return getLinkToRule(name);
    case 'Variables':
      return getLinkToVariable(name);
    case 'Groups':
      return getLinkToGroup(name);
    case 'Data Certifications':
      return ADMIN_DATA_CERTIFICATIONS;
    default:
      return ROUTE_NOT_FOUND;
  }
}

function SideExplorerEntry({ id, text, type }: SideExplorerEntryProps): JSX.Element {
  return (
    <NavLink to={getLink(type, id)} className={({ isActive }) => (isActive ? 'side-explorer-entry_root --active' : 'side-explorer-entry_root')}>
      <div className='side-explorer-entry_container'>
        <div className='side-explorer-entry_file-icon'>{getIconDecorator(type)}</div>
        <div className='side-explorer-entry_file-name'>{text}</div>
      </div>
    </NavLink>
  );
}

export default SideExplorerEntry;
